import { Component, OnInit,Renderer2, } from '@angular/core';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { HttpService } from 'src/app/service/http/http.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MatStepper } from '@angular/material/stepper';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { DetailsPopupComponent } from 'src/app/shared/popups/details-popup/details-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { ReplaceEmployeePopupComponent } from 'src/app/shared/popups/replace-employee-popup/replace-employee-popup.component';
import { saveAs } from 'file-saver';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';


@Component({
  selector: 'app-viewemployeedetails',
  templateUrl: './viewemployeedetails.component.html',
  styleUrls: ['./viewemployeedetails.component.scss'],
})
export class ViewemployeedetailsComponent  implements OnInit {
  subModuleButtonColor: any;
  loggedInUserId:any
  buttonColorName: any;
  loggedInUserCompanyName: any;
  loggedInUserCompanyID: any;
  loggedInUserRole:any;
  userRole: any ;
  empCode: any;
  getUserId: any=2635;
  isFirstEmployee: boolean = false;
  isEmployeeRole:boolean=false;
  officialEmail: any;
  uan: any;
  panNo: any;
  bankAccount: any;
  aadharNo: any;
  employeeData: any = [];
  generalInformationUserForm: FormGroup = new FormGroup({});
  salaryRelatedInformationUserForm: FormGroup = new FormGroup({});
  educationRelatedInformationUserForm: FormGroup = new FormGroup({});
  employeementRelatedUserForm: FormGroup = new FormGroup({});
  priorEmploymentRelatedInformationUserForm: FormGroup = new FormGroup({});
  customFieldObject: any = [];
  constructor(private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private sharedService: SharedService,
    private renderer: Renderer2, private loader: LoaderService, private encryptionService: EncryptionService,
    private currencyPipe: CurrencyPipe) { }

  ngOnInit() {
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');    
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
      this. getCompanyDataByCompID();
      this.getUserByID() ;
  }

 





  
  
  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      this.employeementRelatedUserForm.controls['empCode']?.setValue(data?.data?.employeeIdOfMD);
    })
  }


  getUserByID() {
    console.log(this.getUserId);
    
    this.httpService.callGetService(this.config.getEmployeeById + this.loggedInUserId).subscribe((data: any) => {
      console.log("employeeeeeeeeee-----",data);
      
      this.employeeData = [];
      this.isFirstEmployee = data?.data?.role?.some((ele: any) => ele.displayName == 'MD');
      this.empCode = data?.data?.empCode;
      this.employeeData.push(data?.data);
      if(data?.data?.role?.length==1){
        if(data?.data?.role[0].displayName == 'Employee'){
          this.isEmployeeRole = true;
        }else{
          this.isEmployeeRole = false;
        }
      }
      this.generalInformationUserForm.controls['aadharNo']?.setValue(data?.data?.aadharNo);
      this.generalInformationUserForm.controls['address']?.setValue(data?.data?.address);
      this.generalInformationUserForm.controls['age']?.setValue(data?.data?.age);
      this.salaryRelatedInformationUserForm.controls['annualCTC']?.setValue(data?.data?.annualCtc);
      this.salaryRelatedInformationUserForm.controls['annualTotalCtc']?.setValue(data?.data?.annualTotalCtc);
      this.salaryRelatedInformationUserForm.controls['annualVariablePayBudget']?.setValue(data?.data?.annualVariablePayBudget);
      this.salaryRelatedInformationUserForm.controls['anyOtherAllowancePm']?.setValue(data?.data?.anyOtherAllowancePm);
      this.employeementRelatedUserForm.controls['band']?.setValue(data?.data?.band);
      this.salaryRelatedInformationUserForm.controls['bankAccount']?.setValue(data?.data?.bankAccount);
      this.salaryRelatedInformationUserForm.controls['bankBranchAddress']?.setValue(data?.data?.bankBranchAddress);
      this.salaryRelatedInformationUserForm.controls['bankName']?.setValue(data?.data?.bankName);
      this.salaryRelatedInformationUserForm.controls['basicSalaryPm']?.setValue(data?.data?.basicSalaryPm);
      this.generalInformationUserForm.controls['bloodGroup']?.setValue(data?.data?.bloodGroup);
      this.salaryRelatedInformationUserForm.controls['booksAllowancePm']?.setValue(data?.data?.booksAllowancePm);
      this.employeementRelatedUserForm.controls['catalystRole']?.setValue(data?.data?.catalystRole);
      this.employeementRelatedUserForm.controls['companyName']?.setValue(data?.data?.companyName);
      this.generalInformationUserForm.controls['contactNo']?.setValue(data?.data?.contactNo);
      this.generalInformationUserForm.controls['country']?.setValue(data?.data?.country);
      this.salaryRelatedInformationUserForm.controls['currency']?.setValue(data?.data?.currency);
      this.employeementRelatedUserForm.controls['currentPerformanceRating']?.setValue(data?.data?.currentPerformanceRating);
      this.employeementRelatedUserForm.controls['currentPerformanceScore']?.setValue(data?.data?.currentPerformanceScore);
      this.salaryRelatedInformationUserForm.controls['daPm']?.setValue(data?.data?.daPm);
      this.generalInformationUserForm.controls['dateOfBirth']?.setValue(data?.data?.dateOfBirth);
      this.employeementRelatedUserForm.controls['dateOfJoining']?.setValue(data?.data?.dateOfJoining);
      this.generalInformationUserForm.controls['dateOfMarriage']?.setValue(data?.data?.dateOfMarriage);
      this.employeementRelatedUserForm.controls['dateOfResignation']?.setValue(data?.data?.dateOfResignation);
      this.employeementRelatedUserForm.controls['department']?.setValue(data?.data?.department);
      this.employeementRelatedUserForm.controls['designation']?.setValue(data?.data?.designation);
      this.employeementRelatedUserForm.controls['designationAtDoj']?.setValue(data?.data?.designationAtDoj);
      this.employeementRelatedUserForm.controls['dottedReportingManagerCode']?.setValue(data?.data?.dottedReportingManager?.employeeId);
      this.employeementRelatedUserForm.controls['dottedReportingManagerName']?.setValue(data?.data?.dottedReportingManager?.id);
      this.salaryRelatedInformationUserForm.controls['educationAllowancePm']?.setValue(data?.data?.educationAllowancePm);
      this.generalInformationUserForm.controls['emergencyContactNo']?.setValue(data?.data?.emergencyContactNo);
      this.employeementRelatedUserForm?.controls['empCode']?.setValue(data?.data?.empCode);
      this.employeementRelatedUserForm?.controls['empStatus']?.setValue(data?.data?.empStatus);
      this.salaryRelatedInformationUserForm.controls['employeePfPm']?.setValue(data?.data?.employeePfPm);
      this.salaryRelatedInformationUserForm.controls['employerPfPm']?.setValue(data?.data?.employerPfPm);
      this.employeementRelatedUserForm.controls['employmentCategory']?.setValue(data?.data?.employmentCategory);
      this.employeementRelatedUserForm.controls['employmentType']?.setValue(data?.data?.employmentType);
      this.salaryRelatedInformationUserForm.controls['entertainmentAllowancePm']?.setValue(data?.data?.entertainmentAllowancePm);
      this.salaryRelatedInformationUserForm.controls['esicPm']?.setValue(data?.data?.esicPm);
      this.generalInformationUserForm.controls['fathersName']?.setValue(data?.data?.fathersName);
      this.generalInformationUserForm.controls['firstName']?.setValue(data?.data?.firstName);
      this.salaryRelatedInformationUserForm.controls['fuelAllowancePm']?.setValue(data?.data?.fuelAllowancePm);
      this.generalInformationUserForm.controls['gender']?.setValue(data?.data?.gender);
      this.employeementRelatedUserForm.controls['grade']?.setValue(data?.data?.grade);
      this.salaryRelatedInformationUserForm.controls['grossSalaryPm']?.setValue(data?.data?.grossSalaryPm);
      this.employeementRelatedUserForm.controls['groupName']?.setValue(data?.data?.groupName);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute']?.setValue(data?.data?.highestEducationInstitute);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute2']?.setValue(data?.data?.highestEducationInstitute2);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute3']?.setValue(data?.data?.highestEducationInstitute3);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks']?.setValue(data?.data?.highestEducationMarks);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks2']?.setValue(data?.data?.highestEducationMarks2);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks3']?.setValue(data?.data?.highestEducationMarks3);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification']?.setValue(data?.data?.highestEducationQualification);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification2']?.setValue(data?.data?.highestEducationQualification2);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification3']?.setValue(data?.data?.highestEducationQualification3);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing']?.setValue(data?.data?.highestEducationYearOfPassing);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing2']?.setValue(data?.data?.highestEducationYearOfPassing2);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing3']?.setValue(data?.data?.highestEducationYearOfPassing3);
      this.educationRelatedInformationUserForm.controls['highestProfessionalInstitute']?.setValue(data?.data?.highestProfessionalInstitute);
      this.educationRelatedInformationUserForm.controls['highestProfessionalMarks']?.setValue(data?.data?.highestProfessionalMarks);
      this.educationRelatedInformationUserForm.controls['highestProfessionalQualification']?.setValue(data?.data?.highestProfessionalQualification);
      this.educationRelatedInformationUserForm.controls['highestProfessionalYearOfPassing']?.setValue(data?.data?.highestProfessionalYearOfPassing);
      this.employeementRelatedUserForm.controls['hodCode']?.setValue(data?.data?.hod?.employeeId);
      this.employeementRelatedUserForm.controls['hodName']?.setValue(data?.data?.hod?.id);
      this.salaryRelatedInformationUserForm.controls['hraPm']?.setValue(data?.data?.hraPm);
      this.generalInformationUserForm.controls['id']?.setValue(data?.data?.id);
      this.salaryRelatedInformationUserForm.controls['ifscCode']?.setValue(data?.data?.ifscCode);
      this.salaryRelatedInformationUserForm.controls['incrementOn']?.setValue(data?.data?.incrementOn);
      this.generalInformationUserForm.controls['isRelativeWorking']?.setValue(data?.data?.isRelativeWorking);
      this.generalInformationUserForm.controls['isReplacement']?.setValue(data?.data?.isReplacement);
      this.employeementRelatedUserForm.controls['isVacant']?.setValue(data?.data?.isVacant);
      this.generalInformationUserForm.controls['lastName']?.setValue(data?.data?.lastName);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDepartment']?.setValue(data?.data?.lastOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDesignation']?.setValue(data?.data?.lastOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDoj']?.setValue(data?.data?.lastOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationLwd']?.setValue(data?.data?.lastOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationName']?.setValue(data?.data?.lastOrganisationName);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDepartment']?.setValue(data?.data?.lastToLastOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDesignation']?.setValue(data?.data?.lastToLastOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDoj']?.setValue(data?.data?.lastToLastOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationLwd']?.setValue(data?.data?.lastToLastOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationName']?.setValue(data?.data?.lastToLastOrganisationName);
      this.employeementRelatedUserForm.controls['lastWorkingDate']?.setValue(data?.data?.lastWorkingDate);
      this.employeementRelatedUserForm.controls['lastYearPerformanceRating']?.setValue(data?.data?.lastYearPerformanceRating);
      this.employeementRelatedUserForm.controls['lastYearPerformanceScore']?.setValue(data?.data?.lastYearPerformanceScore);
      this.salaryRelatedInformationUserForm.controls['ltaPm']?.setValue(data?.data?.ltaPm);
      this.salaryRelatedInformationUserForm.controls['lwfPm']?.setValue(data?.data?.lwfPm);
      this.generalInformationUserForm.controls['maritalStatus']?.setValue(data?.data?.maritalStatus);
      this.salaryRelatedInformationUserForm.controls['medicalAllowancePm']?.setValue(data?.data?.medicalAllowancePm);
      this.salaryRelatedInformationUserForm.controls['monthlyCTC']?.setValue(data?.data?.monthlyCtc);
      this.generalInformationUserForm.controls['mothersName']?.setValue(data?.data?.mothersName);
      this.generalInformationUserForm.controls['noOfChildren']?.setValue(data?.data?.noOfChildren);
      this.employeementRelatedUserForm.controls['noOfPromotions']?.setValue(data?.data?.noOfPromotions);
      this.employeementRelatedUserForm.controls['workLocationCity']?.setValue(data?.data?.workLocationCity);
      this.employeementRelatedUserForm.controls['officialEmail']?.setValue(data?.data?.officialEmail);
      this.salaryRelatedInformationUserForm.controls['otherAllowancePm']?.setValue(data?.data?.otherAllowancePm);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDepartment']?.setValue(data?.data?.otherOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDesignation']?.setValue(data?.data?.otherOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDoj']?.setValue(data?.data?.otherOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationLwd']?.setValue(data?.data?.otherOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationName']?.setValue(data?.data?.otherOrganisationName);
      this.salaryRelatedInformationUserForm.controls['otherRetiralPm']?.setValue(data?.data?.otherRetiralPm);
      this.generalInformationUserForm.controls['panNo']?.setValue(data?.data?.panNo);
      this.generalInformationUserForm.controls['permanentAddress']?.setValue(data?.data?.permanentAddress);
      this.generalInformationUserForm.controls['personalEmail']?.setValue(data?.data?.email);
      this.salaryRelatedInformationUserForm.controls['processOfVp']?.setValue(data?.data?.processOfVp);
      this.salaryRelatedInformationUserForm.controls['ptPm']?.setValue(data?.data?.ptPm);
      this.generalInformationUserForm.controls['replacementId']?.setValue(data?.data?.replacementId);
      this.employeementRelatedUserForm.controls['reportingManagerCode']?.setValue(data?.data?.reportingManager?.employeeId);
      this.employeementRelatedUserForm.controls['reportingManagerName']?.setValue(data?.data?.reportingManager?.id);
      this.employeementRelatedUserForm.controls['retirementAge']?.setValue(data?.data?.retirementAge);
      this.salaryRelatedInformationUserForm.controls['salaryStatus']?.setValue(data?.data?.salaryStatus);
      this.generalInformationUserForm.controls['salutation']?.setValue(data?.data?.salutation);
      this.salaryRelatedInformationUserForm.controls['specialAllowancePm']?.setValue(data?.data?.specialAllowancePm);
      this.generalInformationUserForm.controls['spouseName']?.setValue(data?.data?.spouseName);
      this.salaryRelatedInformationUserForm.controls['statutoryBonusPm']?.setValue(data?.data?.statutoryBonusPm);
      this.employeementRelatedUserForm.controls['subDepartment']?.setValue(data?.data?.subDepartment);
      this.employeementRelatedUserForm.controls['temporaryEmpId']?.setValue(data?.data?.temporaryEmpId);
      this.generalInformationUserForm.controls['totalExperience']?.setValue(data?.data?.totalExperience);
      this.salaryRelatedInformationUserForm.controls['totalRetiralPm']?.setValue(data?.data?.totalRetiralPm);
      this.generalInformationUserForm.controls['uan']?.setValue(data?.data?.uan);
      this.salaryRelatedInformationUserForm.controls['washingAllowancePm']?.setValue(data?.data?.washingAllowancePm);
      this.employeementRelatedUserForm.controls['workLocationCity']?.setValue(data?.data?.workLocationCity);
      this.employeementRelatedUserForm.controls['workLocationState']?.setValue(data?.data?.workLocationState);
      this.generalInformationUserForm.controls['workingRelativeName']?.setValue(data?.data?.workingRelativeName);
      this.generalInformationUserForm.controls['workingRelativeRelation']?.setValue(data?.data?.workingRelativeRelation);
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceRating']?.setValue(data?.data?.yearBeforeLastYearPerformanceRating);
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceScore']?.setValue(data?.data?.yearBeforeLastYearPerformanceScore);

      this.officialEmail = data?.data?.officialEmail;
      this.uan = data?.data?.uan;
      this.panNo = data?.data?.panNo;
      this.bankAccount = data?.data?.bankAccount;
      this.aadharNo = data?.data?.aadharNo;
      for(let i=0; i<this.customFieldObject.length;i++){
        for(let j=0; j<data?.data?.customValues.length;j++){
          if(this.customFieldObject[i].fieldId == data?.data?.customValues[j].fieldId){
            this.customFieldObject[i].fieldName = data?.data?.customValues[j].fieldName,
            this.customFieldObject[i].fieldValue = data?.data?.customValues[j].fieldValue,
            this.customFieldObject[i].id= data?.data?.customValues[j].id
          }
        }
      }
      if(data?.data?.empStatus == 'Exited'){
        // this.checkUanNo();
        // this.checkAccountNo();
        // this.checkPanNo();
        // this.checkAadharNo();
        // this.checkEmailInTheSystem();
        // this.checkEmpCode();
      }
    
    })
  }


  

}
